import type { CustomTheme } from '../../../types/custom-theme';
import type { Product } from '../../../types/product';

const baseCarousel: CustomTheme.VariantCSSKeys<CarouselVariantsType> = {
  default: {},
  featuredVideo: {},
};

const carousel: Product.VariantKeyModes<CarouselVariantsType> = {
  products: {
    chart: baseCarousel,
    chartblog: baseCarousel,
    co: baseCarousel,
    edu: baseCarousel,
    scale: baseCarousel,
    spark: baseCarousel,
  },
};

export type CarouselVariantsType = 'default' | 'featuredVideo';
export const carouselVariants = Object.keys(baseCarousel) as CarouselVariantsType[];

export default carousel;
